import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            真实口碑
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            追剧热评
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-2xl mx-auto">
            来看看追剧伙伴们怎么说，吃瓜视频上的每一部剧都值得被认真对待
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-xl">
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-foreground-900 text-sm">{comment.name}</h3>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <span className="inline-block mt-0.5 text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                    {comment.drama}
                  </span>
                </div>
                <div className="flex items-center gap-1 text-foreground-400">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}